import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AtSign, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger,
} from "@/components/ui/dialog";
import { api } from "@/lib/apiClient";

export const MentionInbox = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [mentions, setMentions] = useState(null);
  const [count, setCount] = useState(0);

  const load = async () => {
    try {
      const { data } = await api.get("/mentions");
      setMentions(data.mentions);
      setCount(data.mentions.length);
    } catch { setMentions([]); }
  };

  useEffect(() => { load(); }, []);
  useEffect(() => { if (open) load(); }, [open]);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" className="rounded-full border-white/15 bg-transparent hover:bg-white/5 text-white relative" data-testid="mentions-btn">
          <AtSign className="w-4 h-4 mr-1" /> Mentions
          {count > 0 && (
            <span className="absolute -top-1.5 -right-1.5 bg-[#FF007F] text-white text-xs w-5 h-5 rounded-full flex items-center justify-center" data-testid="mentions-count">{count}</span>
          )}
        </Button>
      </DialogTrigger>
      <DialogContent className="bg-zinc-950 border-white/10 text-white sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl tracking-tight">Your mentions</DialogTitle>
          <DialogDescription className="text-white/50">Every note across your projects that flags you.</DialogDescription>
        </DialogHeader>
        {mentions === null ? (
          <div className="flex justify-center py-8"><Loader2 className="w-6 h-6 animate-spin text-[#00E5FF]" /></div>
        ) : mentions.length === 0 ? (
          <p className="text-sm text-white/40 py-6 text-center" data-testid="mentions-empty">No one has mentioned you yet.</p>
        ) : (
          <div className="space-y-2 max-h-96 overflow-y-auto">
            {mentions.map((m) => (
              <button key={m.comment_id} onClick={() => { setOpen(false); navigate(`/studio/${m.project_id}`); }}
                className="w-full text-left bg-black border border-white/10 rounded-lg p-3 hover:border-[#00E5FF]/40 transition-colors" data-testid={`mention-item-${m.comment_id}`}>
                <div className="flex items-center gap-2">
                  <span className="text-sm font-display text-[#00E5FF]">{m.user_name}</span>
                  <span className="text-xs text-white/30">in {m.project_title}</span>
                </div>
                <p className="text-sm text-white/70 font-light mt-1">{m.text}</p>
              </button>
            ))}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
